import type { ProductCategory } from '../types';

// Short labels for the products-page filter chips.
export const CATEGORY_LABELS: Record<ProductCategory, string> = {
  crunch: 'Crunch',
  granola: 'Granola',
  blends: 'Blends',
  other: 'Other',
};

// Friendlier names for the footer "Shop" links.
export const CATEGORY_SHOP_LABELS: Record<ProductCategory, string> = {
  crunch: 'Seed Crunch',
  granola: 'Granola',
  blends: 'Blends',
  other: 'Other Snacks',
};
